import { render, staticRenderFns } from "./DiscoveryHistory.vue?vue&type=template&id=6ad261b8&scoped=true"
import script from "./DiscoveryHistory.vue?vue&type=script&lang=js"
export * from "./DiscoveryHistory.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryHistory.vue?vue&type=style&index=0&id=6ad261b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad261b8",
  null
  
)

export default component.exports